import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import ClientList from "src/components/Process-Associate-MIS/Client/Client-list";

// ----------------------------------------------------------------------

export default function ProcessAssociateClients() {
  return (
    <>
      <Helmet>
        <title> Clients </title>
      </Helmet>

      <Container maxWidth="xl">
        <ClientList />
      </Container>
    </>
  );
}
